import { Culture } from '../../types';

export const ojibwe: Culture = {
  name: 'Ojibwe',
  languageFamily: 'Algic',
  terms: [
    {
      word: 'Boozhoo',
      phonetic: 'boo-zhoo',
      description: 'Ojibwe greeting meaning "hello."'
    },
    {
      word: 'Gitchi Manitou',
      phonetic: 'gih-chee mah-nih-too',
      description: 'Ojibwe term for "Great Spirit" or "Creator."'
    },
    {
      word: 'Makwa',
      phonetic: 'mah-kwah',
      description: 'Ojibwe word for "bear."'
    },
    {
      word: 'Manidoo',
      phonetic: 'mah-nih-doo',
      description: 'Ojibwe word meaning "spirit" or "spiritual being."'
    },
    {
      word: 'Miigwech',
      phonetic: 'mee-gwetch',
      description: 'Ojibwe word for "thank you."'
    },
    {
      word: 'Mino-Bimaadiziwin',
      phonetic: 'mee-noh bih-mah-dih-zih-win',
      description: 'Ojibwe phrase meaning "the good life" or "living well."'
    },
    {
      word: 'Nibi',
      phonetic: 'nee-bee',
      description: 'Ojibwe word for "water."'
    },
    {
      word: 'Nibinaabe',
      phonetic: 'nih-bih-nah-beh',
      description: 'Ojibwe term meaning "mermaid" or "water spirit."'
    }
  ]
};